import sanityClient from '@sanity/client';

export default sanityClient({
    dataset: "production",
    projectId: "9gzz7muj"
});